import React, { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getRawHtml, getVideoLink } from 'features/page-model/ducks/get-model';
import { MainLayout } from '../main-layout';
import { article } from './styles';
import { decode } from 'js-base64';

export const Advice: FC = () => {
  const rawHtml = useSelector(getRawHtml);
  const videoLink = useSelector(getVideoLink);

  useEffect(() => {
    if (videoLink) {
      const iframe = document.body.querySelector('iframe');
      if (iframe) iframe.src = videoLink;
    }
  }, [videoLink]);

  if (!rawHtml) return null;

  return (
    <MainLayout>
      <div className={article} dangerouslySetInnerHTML={{ __html: decode(rawHtml) }}></div>
    </MainLayout>
  );
};
